type Tone = "success" | "warning" | "danger" | "info" | "neutral" | "purple";

const TONES: Record<Tone, string> = {
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  danger: "bg-red-50 text-red-700",
  info: "bg-blue-50 text-blue-700",
  neutral: "bg-gray-100 text-gray-600",
  purple: "bg-hc_F4EBFA text-honeConnectPurple",
};

const DOTS: Record<Tone, string> = {
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  danger: "bg-red-500",
  info: "bg-blue-500",
  neutral: "bg-gray-400",
  purple: "bg-honeConnectPurple",
};

// Map the status strings used across the API to a colour tone.
export const toneForStatus = (status?: string | null): Tone => {
  switch ((status ?? "").toUpperCase()) {
    case "ACTIVE":
    case "APPROVED":
    case "PAID":
    case "SUCCESS":
    case "SUCCESSFUL":
    case "COMPLETED":
    case "ACCEPTED":
    case "YES":
      return "success";
    case "FLAGGED":
    case "PENDING":
      return "warning";
    case "REMOVED":
    case "FAILED":
    case "REJECTED":
    case "NO":
      return "danger";
    default:
      return "neutral";
  }
};

const StatusPill = ({
  label,
  tone,
}: {
  label: string;
  tone?: Tone;
}) => {
  const t = tone ?? toneForStatus(label);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium capitalize ${TONES[t]}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${DOTS[t]}`} />
      {label.toLowerCase()}
    </span>
  );
};

export default StatusPill;
